import { AxiosError } from "axios"
import { useQuery } from "react-query"
import { RequestParameters } from "../interfaces"
import { getBenchmarkSalesTimeline } from "../service"
import { validateFiltersForBenchmark } from "../utils/utils"
import { NON_OPTION, SELECTED_METRIC } from "../components/Timeline/constants"

const BENCHMARK_SALES_TIMELINE_QUERY = "BENCHMARK_SALES_TIMELINE_QUERY"

export const useGetTimeLineBenchmark = (filters: RequestParameters) => {
	const {
		data: timelineData,
		isFetching: isPendingRequest,
		isError,
		error,
		refetch,
		isSuccess,
	} = useQuery<any, AxiosError>(
		[BENCHMARK_SALES_TIMELINE_QUERY, filters],
		() => {
			if (filters.selectedMetric === SELECTED_METRIC[NON_OPTION]) return
			return getBenchmarkSalesTimeline(filters)
		},
		{
			enabled: validateFiltersForBenchmark(filters),
			retry: false,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
		}
	)

	return { timelineData, isPendingRequest, isError, error, refetch, isSuccess }
}
